/*********************** Custom JS for Boost AI Search & Discovery  ************************/
const isSearchPage = () => {
  return boostSDAppConfig?.generalSettings?.page === 'search';
}
const isCollectionPage = () => {
  return boostSDAppConfig?.generalSettings?.page === 'collection';
};
if (window.boostSDAppConfig) {
  if(!isSearchPage() && !isCollectionPage()) {
    boostSDAppConfig.themeSettings.cart.enableCart = false;
  }
}
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    const changeCollectionHeader = {
      name: "Cart",
      apply() {
        return {
          afterRender(element) {

            try {
                 const props = element.getParams().props

              if(props.isOpen) {
                let cartModels = document.querySelectorAll('.boost-sd__modal')
                if(cartModels && cartModels.length > 1) {
                  cartModels[0].remove()
                }
              }
            } catch (error) {
              console.log(error)
            }

          },
        };
      },
    };

    componentRegistry.useComponentPlugin("Cart", changeCollectionHeader);
  },
]);